
import { Camera, Upload } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useRef } from "react";

interface UploadControlsProps {
  isUploading: boolean;
  isMobile: boolean;
  onFileChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const UploadControls = ({ isUploading, isMobile, onFileChange }: UploadControlsProps) => {
  const fileInputRef = useRef<HTMLInputElement>(null);
  const cameraInputRef = useRef<HTMLInputElement>(null);
  
  const handleUploadClick = () => {
    fileInputRef.current?.click();
  };
  
  const handleCameraClick = () => {
    cameraInputRef.current?.click();
  };
  
  return (
    <div className="flex gap-2">
      <Button 
        variant="outline" 
        size="sm" 
        className="flex items-center gap-1"
        disabled={isUploading}
        onClick={handleUploadClick}
      >
        <Upload className="h-4 w-4" />
        {isUploading ? "Uploading..." : "Upload"}
      </Button>
      <Input
        type="file"
        accept="image/*"
        onChange={onFileChange}
        className="hidden"
        id="avatar-upload"
        disabled={isUploading}
        ref={fileInputRef}
      />
      
      {isMobile && (
        <>
          <Button 
            variant="outline" 
            size="sm" 
            className="flex items-center gap-1"
            disabled={isUploading}
            onClick={handleCameraClick}
          >
            <Camera className="h-4 w-4" />
            {isUploading ? "Uploading..." : "Camera"}
          </Button>
          <Input
            type="file"
            accept="image/*"
            capture="user"
            onChange={onFileChange}
            className="hidden"
            id="avatar-camera"
            disabled={isUploading}
            ref={cameraInputRef}
          />
        </>
      )}
    </div>
  );
};
